<template>
  <div class="operation">
    <el-dialog
        title="输入操作密码"
        :visible.sync="operationVisible"
        width="30%"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        center>
      <span style="text-align: center"><i style="color: #E6A23C" class="el-icon-warning"></i> 该操作需要输入操作密码</span>
      <el-form :rules="rules" ref="form" :model="form" label-width="80px">
        <el-form-item prop="operationPassword" label="操作密码" style="margin-bottom: 0;margin-top: 15px">
          <el-input type="password" v-model="form.operationPassword" placeholder="请输入操作密码"></el-input>
        </el-form-item>
        <el-form-item class="operation_btn">
          <el-button type="primary" @click="CloseInfo">取 消</el-button>
          <el-button @click="submitForm('form')">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "OperationConfirmation",
  props: {
    operationVisible: {
      type: Boolean,
      default:false
    }
  },
  data() {
    return {
      rules: {
        operationPassword: [
          {required: true, message: '请输入操作密码', trigger: 'blur'},
        ]
      },
      form: {
        operationPassword: ''
      }
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.checkOperationPassword()
        } else {
          return false;
        }
      });
    },
    CloseInfo(){
      this.$emit('closeOperation','close')
    },
    async checkOperationPassword(){
      const { data: resData } = await this.$post(
          `staff/check/operate/${this.form.operationPassword}`
      );
      if (resData.result != 200) return;
      this.$emit('closeOperation','open')
      window.sessionStorage.setItem('operationKey',this.form.operationPassword)
      this.form.operationPassword = ''
    }
  }
}
</script>

<style scoped lang="scss">
  .operation_btn{
    margin-top: 25px;
    text-align: center;
    .el-form-item__content{
      margin-left: 0 !important;
    }
  }
</style>